import { useContext, useEffect, useState } from 'react'
import Slider from '../Slider/Slider'
import Header from '../Header'
import axios from 'axios'
import Loader from '../Loader/Loader'
import CategoryWiseFiles from '../AudioFiles/CategoryWiseFiles'
import { SearchGlobalContext } from '../Search/SearchGlobalContext'
import Search from '../Search/Search'
import TopContent from '../TopContents/TopContent'
import Modal from '../Modal'
const Home = () => {
  const [sliders, setSlider] = useState([])
  const [loading, setLoading] = useState(true);
  const [categories, setCatgories] = useState([]);
  const [audiofiles, setAudioFiles] = useState([]);
  // const [searchkeys, setSearchKey] = useState([]);
  const [topContent, setTopContents] = useState([]);
  // const [mostListened, setMostListened] = useState([]);
  const { searchResults } = useContext(SearchGlobalContext)
  const [dw, setWidth] = useState(0)
  const mainDomain = process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info';
  const fromMainDomain = window.location.hostname === mainDomain || process.env.REACT_APP_DOMAIN === 'main';
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const userId = localStorage.getItem('dastaan__user_id');
    // On dastaan.info, prompt login on first visit (with skip option)
    // Don't re-prompt if user already skipped this session
    const skipped = sessionStorage.getItem('dastaan__login_skipped');
    if (fromMainDomain && !userId && !skipped) {
      setShowModal(true);
    }
    getHomePageData()
  }, [])
  const getHomePageData = () => {
    setLoading(true)
    const data = JSON.stringify({
      'user_id': localStorage.getItem('dastaan__user_id') != null ? localStorage.getItem('dastaan__user_id') : 0
    });
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/home`,
      headers: {
        'Authorization': localStorage.getItem('dastaan__token'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      data: data
    };
    axios.request(config).then((response) => {
      setLoading(false)
      setCatgories(response?.data?.Podcast_App?.categories)
      setAudioFiles(response?.data?.Podcast_App?.audio_file_data)
      setSlider(response?.data?.Podcast_App?.slider)
      setTopContents(response?.data?.Podcast_App?.top_contents)
      localStorage.setItem("dastaan__plan_active", response?.data?.Podcast_App?.user_plan_status);
      // setSearchKey(response?.data?.Podcast_App?.search_keywords)
    })
  }
  useEffect(() => {
    const w = window.innerWidth
    setWidth(w)
  })
  return (
    <>
      {loading ?
        (
          <Loader loading={loading} />) : (
          <>
            {
              dw <= 768 ? <Header /> : ''
            }
            {
              searchResults.length > 0 ? (<Search />) : (
                <>
                  <Slider sliders={sliders} />
                  <TopContent topContent={topContent} />
                  {/* <MostListened mostListened={mostListened} /> */}
                  <CategoryWiseFiles audiofiles={audiofiles} categories={categories} />
                </>
              )
            }
            {/*  */}
          </>
        )}
      <Modal show={showModal} onClose={() => setShowModal(false)} hideCloseButton={fromMainDomain} />
    </>
  )
}
export default Home
